import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AccessLevel, DashboardNotifications } from '@dev/ee-api/ee-api-models';

import { ShowDialogParams } from '@/store/dialog/types';
import {
    getDashboardSeenNotificationsStore,
    UpdateDashboardSeenNotification,
} from '@/store/dashboardSeenNotifications/actions';
import { useAccessLevel } from '@/services/hooks/useAccessLevel';
import { AITextToolModalBody } from '../components/AITextToolModal';

export const useGetDisposableAITextToolModalParams = (): {
    getDisposableAITextToolModalParams: () => ShowDialogParams;
    displayAiTextToolModal: boolean;
} => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { list: dashboardSeenNotifications, isLoaded: dashboardSeenNotificationsLoaded } = useSelector(
        getDashboardSeenNotificationsStore
    );
    const { hasAccessLevel } = useAccessLevel();
    const canViewAITools = hasAccessLevel(AccessLevel.ViewAITools);

    const displayAiTextToolModal =
        dashboardSeenNotificationsLoaded &&
        !dashboardSeenNotifications?.includes(DashboardNotifications.AITextToolNotification) &&
        canViewAITools;
    const onModalClose = (): void => {
        dispatch(UpdateDashboardSeenNotification(DashboardNotifications.AITextToolNotification));
    };

    const getDisposableAITextToolModalParams = (): ShowDialogParams => ({
        title: t('aitexttool_modaltitle'),
        cancelLabel: t('close'),
        onClickCancel: onModalClose,
        body: <AITextToolModalBody />,
        id: 'aitexttoolmodal',
    });
    return { getDisposableAITextToolModalParams, displayAiTextToolModal };
};
